export default ({ store }) => {
  store.dispatch('loadLocalSettings')
}
